import React, { useState, useRef } from 'react';


import Scene3D from "./Scene3D"

import iconMic from "../assets/icons/Mic.png";
import { contextData } from '../assets/context.data';
import { languageData } from '../assets/language.data';
import iconLanguageES from "../assets/icons/es.png";
import iconLanguageEN from "../assets/icons/en.png";

import iconSpeaker from "../assets/icons/speaker.png";

import iconRecord from "../assets/icons/record.png";
import iconRecording from "../assets/icons/recording.png";
import iconStop from "../assets/icons/stop.png";
import iconClose from "../assets/icons/close.png";
import iconAR from "../assets/icons/ar.png";


import iconKeyboard from "../assets/icons/keyboard.png";

import iconLoading from "../assets/icons/loading.png";
import iconLogoIntro from "../assets/logos/LogoHD2_icon.png";
import iconLogoPowered from "../assets/logos/LogoHD2_icon.png";

import iconOption from "../assets/icons/option.png";
import iconOptionSelected from "../assets/icons/optionSelected.png";

import useScreenOrientation from './helpers/useScreenOrientation';
import isMobileDevice from './helpers/isMobileDevice';
import GetBrowserInfo from './helpers/GetBrowserInfo';

export default function SceneUI() {

  interface OpenAIMessage {
    role: string,
    content: string
  }
  interface OpenAICompletionsRaw {
    model: string,
    temperature: number,
    messages: OpenAIMessage[];
  }
  const context: any = contextData()
  let contextDefinition: OpenAICompletionsRaw = {
    model: "gpt-3.5-turbo",
    temperature: 0.7,
    messages: [ { role: 'system', content: context.text } ]//contexto
  };


  interface HuggingFaceMessage {
    message: string,
    type: string
  }
  interface HuggingFaceCompletionsRaw {
    question: string,
    history: HuggingFaceMessage[];
  }
  let huggingFaceDefinition: HuggingFaceCompletionsRaw = {
    question: "",
    history: [{
        message: '¡Hola! Soy una copia digital de Jose Maria Balaguer, un consejero espiritual. Mi objetivo es brindar soporte y guía espiritual. ¿En qué puedo ayudarte hoy? Recuerda que mi especialidad son temas relacionados con la vida y la obra de Balaguer, así como consejos espirituales. ¡Que la virgen te acompañe!',
        type: 'AI Message'
      }]
  };

  const [conversationHistory, setConversationHistory] = useState(huggingFaceDefinition);//contextDefinition
  //AUDIO CAPTURER
  const [audioReplyURL, setAudioReplyURL] = useState('');
  const [audioUserURL, setAudioUserURL] = useState('');
  const [isModelSpeaking, setModelSpeaking] = useState(false);
  const [isRecording, setIsRecording] = useState(false);

  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const audioReplayFromAI = useRef<HTMLAudioElement>(null);
  const audioFromUser = useRef<HTMLAudioElement>(null);
  const browserInfo = GetBrowserInfo();

  //UI
  const language: any = languageData()
  const [dictionary, setDictionary] = useState<any>(language.es);
  const [selectedLanguage, setSelectedLanguage] = useState("es");
  const [showBlock, setShowBlock] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [isSceneLoaded, setSceneLoaded] = useState(false);
  const [isSpeakerMenu, setSpeakerMenu] = useState(false);
  const [isARCapable, setARCapable] = useState(false);
  const [isInARMode, setInARMode] = useState(false);
  const [isMicMenu, setMicMenu] = useState(false);
  const [switchAR, setSwitchAR] = useState(false);
  const [isARSupported, setARSupported] = useState(false);
  const [isOnARMode, setOnARMode] = useState(false);

  const isLandscape = useScreenOrientation();
  const isMobile = isMobileDevice();

  const [staticAudios, setStaticAudios] = React.useState([]);

  React.useEffect(() => {

    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage && language[savedLanguage]) {
      setDictionary(language[savedLanguage]);
    }

    const audio = audioReplayFromAI.current;
    
    const handlePlay = () => {
      setModelSpeaking(true);
    };

    const handlePause = () => {
      setModelSpeaking(false);
    };

    if (audio) {
        audio.addEventListener('play', handlePlay);
        audio.addEventListener('pause', handlePause);
        return () => {
            audio.removeEventListener('play', handlePlay);
            audio.removeEventListener('pause', handlePause);
        };
    }
  }, []);

  React.useEffect(() => {
    localStorage.setItem('selectedLanguage', selectedLanguage);

    if(language[selectedLanguage])
    setDictionary(language[selectedLanguage])

    var audios: any = [];
    audios.push("./audios/audio1."+selectedLanguage+".mp3")
    audios.push("./audios/audio2."+selectedLanguage+".mp3")
    audios.push("./audios/audio3."+selectedLanguage+".mp3")
    setStaticAudios(audios)
  }, [selectedLanguage]);

  React.useEffect(() => {
    if(audioReplyURL.length > 0 && audioReplayFromAI.current){
      audioReplayFromAI.current.volume = 1.0
      audioReplayFromAI.current.currentTime = 0
      audioReplayFromAI.current.play()
      setShowLoading(false)
    }
  },[audioReplyURL]);

  const startRecording = async () => {
    try {
      setIsRecording(true)
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.addEventListener("dataavailable", event => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      });

      mediaRecorderRef.current.addEventListener("stop", async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: browserInfo.isOSiOS === true ? 'audio/mp4' : 'audio/mp3' }); //application/octet-stream , audio/mp3
        if(browserInfo.isOSiOS === true){
          stream.getTracks().forEach( track => track.stop() );
        }
        //setAudioUserURL(URL.createObjectURL(audioBlob)) //FOR TESTING ONLY
        serviceUserAudioToText(audioBlob);
      });

      if(browserInfo.isOSiOS === true){
        mediaRecorderRef.current.start(1000);
      }else{
        mediaRecorderRef.current.start();
      }
      
      setIsRecording(true);
    } catch (err) {
      setIsRecording(false)
      console.error("Could not start recording", err);
    }
  };

  const stopRecording = () => {
    setIsRecording(false)
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  //SERVICE 1
  const serviceUserAudioToText = (audioBlob: Blob) => {
    setShowLoading(true)
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer sk-proj-22V9EVeDG5X4aIACOg4pT3BlbkFJjN1ChdlsevO5Kx6PDxk4");

    const formdata = new FormData();
    formdata.append("model", "whisper-1");
    formdata.append("file", audioBlob, "Josemaria.wav");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata
    };

    fetch("https://api.openai.com/v1/audio/transcriptions", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("Transcripción de Audio: " + result.text)
        if(result.text.length > 3){
          serviceUserTextToAIText(result.text)
        }else{
          setShowLoading(false)  
        }
      })
      .catch((error) => {
        console.error(error)
        setShowLoading(false)
      });
  };
/*
  //SERVICE 2
  const serviceUserTextToAIText = (message: string) => {
    
    let tempConversationHistory = conversationHistory;
    const userMessage : OpenAIMessage = { role: "user", content: message }
    tempConversationHistory.messages.push(userMessage)

    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer sk-proj-22V9EVeDG5X4aIACOg4pT3BlbkFJjN1ChdlsevO5Kx6PDxk4");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(tempConversationHistory);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw
    };

    fetch("https://api.openai.com/v1/chat/completions", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        const reply = result.choices[0].message
        const answer : OpenAIMessage = { role: reply.role, content: reply.content }
        tempConversationHistory.messages.push(answer)
        console.log("Respuesta de IA: " + answer.content)
        setConversationHistory(tempConversationHistory)
        serviceAITextToVoice(answer.content)
      })
      .catch((error) => {
        console.error(error)
        setShowLoading(false)
      });
  };
*/
  //SERVICE 2
  const serviceUserTextToAIText = (strMessage: string) => {
    
    let tempConversationHistory = conversationHistory;
    tempConversationHistory.question = strMessage

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(tempConversationHistory);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };
    
    fetch("https://flowise-02i3.onrender.com/api/v1/prediction/6d66a0e3-5e95-4aba-9996-9a203811b1a5", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        const question = result.question;
        const reply = result.text;

        const userMessage : HuggingFaceMessage = { message: question, type: "userMessage" } ;
        tempConversationHistory.history.push(userMessage);
        const iaMessage : HuggingFaceMessage = { message: reply, type: "AI Message" } ;
        tempConversationHistory.history.push(iaMessage);

        console.log("Respuesta de IA: " + reply);
        setConversationHistory(tempConversationHistory);
        serviceAITextToVoice(reply);
      })
      .catch((error) => {
        console.error(error);
        setShowLoading(false);
      });
  };

  //SERVICE 3
  const serviceAITextToVoice = async (message: string) => {

    let rawObject = {
      model_id: "eleven_multilingual_v2",
      text: message,
      voice_settings: { 
        similarity_boost: 0.9,
        stability: 0.9,
        style: 0,
        use_speaker_boost: true
      }
    };

    const myHeaders = new Headers();
    myHeaders.append("xi-api-key", "c3da74c0a9c2d3b1054d0e8cb972f26e");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(rawObject);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw
    };

    const response = await fetch("https://api.elevenlabs.io/v1/text-to-speech/sGnwuQXIe3472PZdimMf?output_format=mp3_44100_128", requestOptions)
    if (response.ok) {
      const blob = await response.blob();
      const audioUrl = URL.createObjectURL(blob);
      setAudioReplyURL(audioUrl)
    }else{
      console.error(`HTTP error! Status: ${response.status}`);
      setShowLoading(false)
    }
  };

  const setLocalSceneLoaded = (value: boolean) => {
    setShowBlock(false)
    setSceneLoaded(value)
  };

  const openSpeakerMenu = () => {
    setSpeakerMenu(true)
    closeMicMenu()
  };

  const closeSpeakerMenu = () => {
    setSpeakerMenu(false)
  };

  const openMicMenu = () => {
    setMicMenu(true)
    closeSpeakerMenu()
  };

  const closeMicMenu = () => {
    setMicMenu(false)
  };

  const SwitchAR = () => {
    setSwitchAR(true);
    setTimeout(() => {
      setSwitchAR(false)
    }, 500)
  };

  const IsARSupported  = (value: boolean) => {
    console.log("ar supported " + value)
    setARSupported(value)
  };

  const IsOnARMode = (value: boolean) => {
    console.log("on ar mode? " + value)
    setOnARMode(value)
  };

  return (
    <div className={`sceneui-container`}>
      {/* SCENE 3D CONFIG ON THE OTHER FILE */}
      <Scene3D sceneLoaded={setLocalSceneLoaded} isARSupported={IsARSupported} isOnARMode={IsOnARMode} switchAR={switchAR} isSpeaking={isModelSpeaking} />


      <div className={`sceneui-footer ${showBlock ? '' : 'active'}`}>
        <img className={`sceneui-footer-img ${isLandscape ? '' : 'portrait'}`} src={iconLogoPowered} alt='' draggable={false} />
      </div>

      {/* SIDEBAR BUTTONS */}
      <div className={`sceneui-sidebar ${showBlock ? '' : 'active'} ${isLandscape ? '' : 'portrait'}`}>

        <div className={`sceneui-sidebar-button${isARSupported ? '' : ' hidden'}${isOnARMode ? ' active' : ''}`} onClick={() => { SwitchAR() }}>
          <img className={`sceneui-sidebar-button-img`} src={iconAR} alt='' draggable={false} />
        </div>
        {/* <div className={`sceneui-sidebar-button ${isSpeakerMenu ? 'active' : ''}`} onClick={() => { openSpeakerMenu() }}>
          <img className={`sceneui-sidebar-button-img`} src={iconSpeaker} alt='' draggable={false} />
        </div>

        <div className={`sceneui-sidebar-button ${isSpeakerMenu ? 'active' : ''}`} onClick={() => { openSpeakerMenu() }}>
          <img className={`sceneui-sidebar-button-img`} src={iconSpeaker} alt='' draggable={false} />
        </div>

        <div className={`sceneui-sidebar-button ${isMicMenu ? 'active' : ''}`} onClick={() => { openMicMenu() }}>
          <img className={`sceneui-sidebar-button-img`} src={iconRecord} alt='' draggable={false} />
        </div>

        <a className={`sceneui-sidebar-button`} href="https://toursusa.imagine-x.co/MetaHumans/TextChat/JoseMaria/">
          <img className={`sceneui-sidebar-button-img`} src={iconKeyboard} alt='' draggable={false} />
        </a> */}
        
      </div>

      {/* MIC MENU */}
      { isMicMenu && 
        <div className={`sceneui-menu-mic`}>
          <div className={`sceneui-menu-mic-container ${isLandscape ? '' : 'portrait'} ${isRecording ? 'recording' : ''}`}>
            
            <div className={`sceneui-menu-mic-container-close`} >
              <img className={`sceneui-menu-mic-container-close-img`} src={iconClose} alt='' draggable={false} onClick={() => { closeMicMenu() }}/>
            </div>

            <div className={`sceneui-menu-mic-container-button`} onClick={() => { isRecording ? stopRecording() : startRecording() }}>
              <div className={`sceneui-menu-mic-button`}>
                <img className={`sceneui-menu-mic-button-img`} src={isRecording ? iconStop : iconRecord} alt='' draggable={false} />
              </div>
            </div>

            <div className={`sceneui-menu-mic-desc`}>
              <div className={`sceneui-menu-mic-desc-text`}>{isRecording ? dictionary.press_to_stop : dictionary.press_to_record}</div>
            </div>
          </div>
        </div>
      }

      {/* SPEAKER MENU */}
      { isSpeakerMenu && 
        <div className={`sceneui-menu-speaker`}>
          <div className={`sceneui-menu-speaker-container ${isLandscape ? '' : 'portrait'} ${isRecording ? 'recording' : ''}`}>
            
            <div className={`sceneui-menu-speaker-container-close`} >
              <img className={`sceneui-menu-speaker-container-close-img`} src={iconClose} alt='' draggable={false} onClick={() => { closeSpeakerMenu() }}/>
            </div>

            <div className={`sceneui-menu-speaker-container-options`}>
              {
                staticAudios.map((audio: any, index: number) =>
                  <div key={index} className={`sceneui-menu-speaker-option`} onClick={() => { setAudioReplyURL(audio) }}>
                    <div className={`sceneui-menu-speaker-option-background`} style={{ backgroundImage: `url(${audioReplyURL === audio ? iconOptionSelected : iconOption})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', width: '100%', height: '100%'}}  draggable={false}>

                    <div className={`sceneui-menu-speaker-option-title`}>
                      {dictionary.message} {index+1}
                    </div>
                    <div className={`sceneui-menu-speaker-option-icon`}>
                      <img className={`sceneui-menu-speaker-option-icon-img`} src={iconSpeaker} alt='' draggable={false} />
                    </div>
                    <div className={`sceneui-menu-speaker-option-desc`}>
                      {dictionary.free}
                    </div>

                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      }

      {/* START AND LOADING BLOCKERS */}
      {showBlock &&
        <div className="sceneui-block">
          {/* <div className={`sceneui-block-text ${isLandscape ? '' : 'portrait'} ${isSceneLoaded === true ? 'active' : ''}`}>{isSceneLoaded === true ? dictionary.press_to_continue : dictionary.loading}</div> */}
          { isSceneLoaded === false &&
            <div className={`sceneui-block-text ${isLandscape ? '' : 'portrait'}`}>{dictionary.loading}</div>
          }
          <img className={`sceneui-block-img ${isLandscape ? '' : 'portrait'}`} src={iconLogoIntro} alt='' draggable={false} />
        </div>
      }
      {showLoading &&
        <div className="sceneui-block">
          <img className={`sceneui-block-loading ${isLandscape ? '' : 'portrait'}`} src={iconLoading} alt='' draggable={false} />
          <div id='loading' className={`sceneui-block-text ${isLandscape ? '' : 'portrait'}`}>{dictionary.loading}</div>
        </div>
      }
      {/* {
        <div className="sceneui-block">
          some
        </div>
      } */}
      <audio id='Test_Audio' ref={audioReplayFromAI} src={audioReplyURL} />

      {/* ONLY FOR AUDIO TESTING */}
      { audioUserURL ? 
        <audio ref={audioFromUser} src={audioUserURL} controls></audio> : null
      }
    </div>
  );
}
